import React from 'react';
import InfoCard from '../../Forms/InfoCard/InfoCard';
import { ProductSettlementStatus } from '../../../types/settlement/SettlementTypes';

interface Props {
  status?: ProductSettlementStatus;
}

const SettlementStatusCard: React.FC<Props> = ({ status }) => {
  if (!status) return null; // 🚫 Evita renderizar si no hay datos

  return (
    <div className="rounded border border-stroke bg-white p-4 shadow dark:border-strokedark dark:bg-boxdark">
      <h3 className="mb-4 text-lg font-semibold text-black dark:text-white">
        Estado del Asentamiento
      </h3>

      <div className="space-y-2 text-sm">
        <InfoCard
          label="Cantidad Comprada"
          value={status.totalPurchased}
          iconKey="purchase"
        />
        <InfoCard
          label="Cantidad Asentada"
          value={status.totalSettled}
          iconKey="settled"
        />
        <InfoCard
          label="Cantidad Restante"
          value={status.remaining}
          iconKey="pendingPurchase"
        />
        <InfoCard
          label="Estado"
          value={status.fullySettled ? 'Asentado totalmente' : 'Pendiente'}
          iconKey={status.fullySettled ? 'check' : 'pause'} // Puedes usar un ícono si lo deseas
        />
      </div>
    </div>
  );
};

export default SettlementStatusCard;
